import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../Auth/AuthProvider';
import { signOut } from '../../api/auth';
import { XpBar } from './XpBar';
import styles from '../../styles/Layout.module.css';
export function Header() {
    const location = useLocation();
    const navigate = useNavigate();
    const { session } = useAuth();
    const [isAdmin, setIsAdmin] = useState(false);
    useEffect(() => {
        if (!session) {
            setIsAdmin(false);
            return;
        }
        fetch('/api/admin/overview', { credentials: 'include' })
            .then(res => setIsAdmin(res.ok))
            .catch(() => setIsAdmin(false));
    }, [session]);
    const handleLogout = async () => {
        await signOut();
        navigate('/login');
    };
    return (_jsxs("header", { className: styles.header, children: [_jsx(Link, { to: "/", className: styles.logo, children: "SQUL" }), _jsxs("nav", { className: styles.nav, children: [session && (_jsx(Link, { to: "/", className: location.pathname === '/' ? styles.activeLink : styles.link, children: "\u0423\u0440\u043E\u043A\u0438" })), _jsx(Link, { to: "/leaderboard", className: location.pathname === '/leaderboard' ? styles.activeLink : styles.link, children: "\u041B\u0438\u0434\u0435\u0440\u044B" }), session && (_jsx(Link, { to: "/progress", className: location.pathname === '/progress' ? styles.activeLink : styles.link, children: "\u041F\u0440\u043E\u0433\u0440\u0435\u0441\u0441" })), session && (_jsx(Link, { to: "/profile", className: location.pathname === '/profile' ? styles.activeLink : styles.link, "data-testid": "profile-link", children: "\u041F\u0440\u043E\u0444\u0438\u043B\u044C" })), isAdmin && (_jsx(Link, { to: "/admin", className: location.pathname === '/admin' ? styles.activeLink : styles.link, "data-testid": "admin-link", children: "\u0410\u0434\u043C\u0438\u043D" }))] }), session && (_jsxs(_Fragment, { children: [_jsx(XpBar, {}), _jsx("button", { onClick: handleLogout, className: styles.logoutBtn, children: "\u0412\u044B\u0439\u0442\u0438" })] }))] }));
}
